				import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class AppHelpInfoService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('AppHelpInfo');
	}
	
	loadAll() : Observable<ePM.Logic.AppHelpInfo[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.AppHelpInfo> {
		return this.myBaseService.save(tempItem, this.url);
	}

	getEdit(id: System.Guid): Observable<ePM.Logic.AppHelpInfo> {
		return this.myBaseService.getEdit(id, this.url);
	}
}
				